import React, {Component} from 'react';
import PropTypes from 'prop-types';
import phone from "../image/phoneNew.png";
import MyIconSvg from "../iconSvg/svg";
import weChatIcon from "../image/wechaticon.png"
import pause from "../image/pause (2).png"
import phoneHead from "../image/iphonex-dark(1).png"
import $ from "jquery"

class PreviewComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPlayVideo: false,
            width:"",
            height:"",
            proportion: 0
        }

    }

    componentDidMount () {
        let record = {...this.props.getByIData, ...this.props.accountInformation};
        let {videoUrl, id, title, head, name, tags} = record;
        this.getVideoWidth(videoUrl,(data)=>{
            console.log(data)
            this.setState({
                width:data.width,
                height:data.height
            })
            if(this.state.width>this.state.height){
                this.setState({
                    proportion:1
                })
            }
        })
    }

    // getWidthAndHeight = async () =>{
    //     let record = {...this.props.getByIData, ...this.props.accountInformation};
    //     let {videoUrl, id, title, head, name, tags} = record;
    //     let {width,height}= await this.getVideoWidth(videoUrl)
    //     console.log(width,height,"22222222222222")
    // }

    getVideoWidth(fileUrl,callback) {
        const that = this;
        return new Promise((resolve, reject) => {
            let aspectRatio = null;
            let url = fileUrl;
            const newvideoUrl = url;
            const videoObj = document.createElement("video");
            videoObj.preload = "metadata";
            videoObj.src = newvideoUrl;
            videoObj.onloadedmetadata = function (evt) {
                URL.revokeObjectURL(newvideoUrl);
                let videoTime = videoObj.duration; // 获取视频的时长
                let width = videoObj.videoWidth; //获取视频的宽
                let height = videoObj.videoHeight; //获取视频的高
                callback({ width, height })
                resolve({ width, height });
            };
        });
    }

    render() {
        let record = {...this.props.getByIData, ...this.props.accountInformation};
        let {videoUrl, id, title, head, name, tags} = record;
        let newTitle = $(`<div>${title}</div>`).text();
        let {isPlayVideo} = this.state;
        let newTages = [];
        tags && tags.length && tags.forEach((item => {
            newTages.push('#' + item)
        }));
        return (
            <div style={{position: 'relative', left: 73, top: 7, width: 235.24, height: 498,}}
                 onClick={() => {
                     if (!isPlayVideo) {
                         this['videoNode' + id].pause();
                         // this['videoNode' + id].currentTime = 0;
                     } else {
                         // this['videoNode' + id].currentTime = 0;
                         this['videoNode' + id].play();
                     }
                     this.setState({isPlayVideo: !isPlayVideo});
                 }}>
                <img style={{width: 235.24, height: 498}} src={phone}/>
                <img style={{width: 235.24,position:"absolute",top:"2px",left:"-1px",zIndex:5}} src={phoneHead}/>
                <div data-vjs-player
                     style={{
                         width: 225,
                         height: 439,
                         position: 'absolute', top: "4px", left: "5px"
                     }}>
                    <video
                        id={"videoCoverSize"}
                        ref={node => this['videoNode' + id] = node}
                        style= {this.state.proportion == 0 ? { height: "100%",width: "100%",objectFit: "cover",borderRadius:"23px 23px 0 0"}:{width:"100%",height:"100%"}}
                        autoPlay={true}//播放器准备好之后，是否自动播放 【默认false】
                        loop={true} //视频播放结束后，是否循环播放
                        controls={false} // 视频控件
                        responsive="true"
                        fluid="true"
                        muted={this.props.muted?this.props.muted:false}//是否静音
                        src={videoUrl}
                    >
                    </video>
                </div>
                {/* 暂停图标*/}
                {isPlayVideo ? <img src={pause} style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: ' -20px',
                    marginLeft: ' -20px',
                    width: 48,
                    height: 48
                }}/> : null}
                {/*点赞,评论,分享*/}
                <div style={{position: 'absolute', top: 219, right: 14}}>
                    <div>
                        <img width={25} height={25} style={{
                            borderRadius: "50%",
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginLeft: '2px'
                        }} src={head}/>
                    </div>
                    <div style={{textAlign: 'center', paddingTop: 16}}>
                        <MyIconSvg type={'like'} style={{size: 17}}/>
                    </div>
                    <div style={{textAlign: 'center', paddingTop: 24}}>
                        <MyIconSvg type={'comment'} style={{size: 17}}/>
                    </div>
                    <div style={{textAlign: 'center', paddingTop: 21}}>
                        <MyIconSvg type={'collect'} style={{size: 17}}/>
                    </div>
                    {this.props.weChatIcon ?
                        <div style={{textAlign: 'center', paddingTop: 21}}>
                            <img src={this.props.weChatIcon ? this.props.weChatIcon : weChatIcon}/>
                            <div style={{
                                fontSize: '12px',
                                color: '#FFFFFF',
                                transform: 'scale(0.5)',
                                fontWeight: '500px'
                            }}>{this.props.text ? this.props.text : '分享'}</div>
                        </div> :
                        <div style={{textAlign: 'center', paddingTop: 17}}>
                            <MyIconSvg type={'share'} style={{size: 17}}/>
                        </div>}
                </div>
                {/*账号名字,视频描述*/}
                <div style={{position: 'absolute', bottom: 57, left: 15, width: 174, height: 75, color: 'white',}}
                     className={"previewDescription"}>
                    <p style={{fontSize: '14px'}}>@{name}</p>
                    <p title={newTitle.concat(newTages.join(''))} style={{fontSize: '10px', marginTop: '8px'}}>
                        <span>{newTitle}</span>
                        <span>{newTages.join('')}</span>
                    </p>
                </div>
                <style>
                    {`
                    .previewDescription{
                     overflow: hidden;
                     text-overflow: ellipsis;
                     display: -webkit-box;
                     -webkit-line-clamp: 3;
                     line-clamp: 2;
                     -webkit-box-orient: vertical;
                     word-break:break-all;
                    }
                    `}
                </style>
            </div>


        );
    }
}

PreviewComponent.propTypes = {};

export default PreviewComponent;